import { FormBuilder, FormGroup } from '@angular/forms';
import { UpdateUserDataInput } from 'src/app/services/API.service';
import { NoteForm } from './forms/note-form';
import { Note } from './note';

export class UserData {
    fb: FormBuilder;
    id: string;
    delete = 0;
    viewed = 0;
    Note: FormGroup;
    createdAt: Date;
    updatedAt: Date;

    constructor(data?) {
        this.fb = new FormBuilder();

        this.Note = this.fb.group(new NoteForm(new Note({ Seq: 0 })));

        if (data) {

            this.id = data.id;
            this.delete = data.delete;
            this.viewed = data.viewed;
            this.createdAt = data.createdAt;
            this.updatedAt = data.updatedAt;

            if (data.Note && data.Note.length > 0) {
                this.Note = this.fb.group(new NoteForm(new Note(data.Note[0])));
            }
        }
    }

    updates() {
        const txt = this.Note.get('TextArea').value;
        const update: UpdateUserDataInput = {
            id: this.id,
            delete: this.delete,
            viewed: this.viewed,
            Note: [{
                Seq: this.Note.get('Seq').value,
                Selected: this.Note.get('Selected').value,
                TextArea: (typeof txt === 'string' ? txt : ' ')
            }]
        };

        return update;
    }
}
